import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { Candidate } from '../../../../types/candidates';
import { successHandler, errorHandler } from '../../../utils';
import {
  CandidateBuilder,
  UpdateCandidateWorkSummaryInput,
  UpdateCandidateWorkSummaryOutput,
} from '../candidates.types';

export const updateCandidateWorkSummary = (builder: CandidateBuilder) =>
  builder.mutation<
    UpdateCandidateWorkSummaryOutput,
    UpdateCandidateWorkSummaryInput
  >({
    query: (options) => ({
      url: `/candidates/${options.candidateId}`,
      method: 'PATCH',
      body: options.data,
    }),
    transformResponse: (queryResponse: { data: Candidate }, _, arg) => {
      successHandler(
        (arg.lang ?? 'en') === 'en'
          ? SuccessMessageEn.UpdateCandidate
          : SuccessMessageEs.UpdateCandidate,
        true
      );
      return queryResponse.data;
    },
    transformErrorResponse: (error, _, arg) => {
      errorHandler(
        '[uploadCandidateInfoAction]',
        (arg.lang ?? 'en') === 'en'
          ? ErrorMessageEn.UpdateCandidatesFail
          : ErrorMessageEs.UpdateCandidateFail,
        error,
        true
      );
      return error.data;
    },
    invalidatesTags: (res, meta, arg) => [
      { type: 'Candidate', Id: arg.candidateId },
    ],
  });
